import React, { useContext, useState, useEffect } from 'react'
import { Container, Row, Col, Button, Pagination } from "react-bootstrap";
import { UserContext } from "../../Context/UserContext";
import LoadingScreen from "../../Layout/LoadingScreen";
import { notify } from "react-notify-toast";
import DeleteTeacher from "./DeleteTeacher.tsx";
import TeachersList from "./TeachersList";
import EditTeacher from "./EditTeacher";
import AddTeacher from "./AddTeacher";
import clientAxios from '../../clients/clientAxios';

export default function Teachers(props) {

  const [loading, setLoading] = useState(true);
  const [mentorList, setMentorList] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
    pageSize: 10
  });
  const [modalState, setModalState] = useState({
    id: "",
    delete: false,
    edit: false,
    name: "",
    email: "",
    isActive: false
  });
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [addTeacher, setAddTeacher] = useState(false);
  const user = useContext(UserContext);
  useEffect(() => {
    getMentors(1)
  }, []);

  useEffect(() => {
    if (modalState.edit) {
      setShowEdit(true)
    } else if (modalState.delete) {
      setShowDelete(true)
    }
  }, [modalState]);

  const getMentors = (page = 1) => {
    setLoading(true);
    clientAxios.get(`/mentors?page=${page}&sortBy=createdAt&sortOrder=-1`, { headers: { "auth-token": localStorage.getItem("JWT") } })
      .then(({ data }) => {
        const mappedMentors = data.data.map(mentor => ({
          ...mentor,
          name: `${mentor.firstName || ''} ${mentor.lastName || ''}`.trim()
        }));
        setMentorList(mappedMentors);
        setPagination({
          currentPage: data.currentPage,
          totalPages: data.totalPages,
          totalRecords: data.totalRecords,
          pageSize: data.pageSize
        });
        setLoading(false);
      })
      .catch((err) => {
        notify.show("No se pudo obtener los mentores", "error");
        setLoading(false);
      });
  }

  if (loading) {
    return <LoadingScreen />
  } else {
    return (
      <Container className="mb-5 mt-5 pl-0 pr-0">
        <AddTeacher
          show={showAdd}
          onHide={() => setShowAdd(false)}
          setAddTeacher={setAddTeacher}
          setValidated={(data) => {
            if (data) {
              getMentors(pagination.currentPage);
            }
          }}
        />
        <EditTeacher
          show={showEdit}
          onHide={() => setShowEdit(false)}
          setValidated={(data) => {
            if (data) {
              getMentors(pagination.currentPage);
            }
          }}
          modalState={modalState}
        />
        <DeleteTeacher
          show={showDelete}
          onHide={() => setShowDelete(false)}
          setValidated={(data) => {
            if (data) {
              getMentors(pagination.currentPage);
            }
          }}
          modalState={modalState}
          setModalState={(data) => setModalState(data)}
        />

        <Row>
          <Col>
            <h1>Lista de mentores / Tutores</h1>
          </Col>
          <Col className="d-flex justify-content-end">
            <div className="bg-light rounded shadow p-3 pl-0 mb-5">
              <Button disabled title="Los mentores se agregan desde Universe" style={{ cursor: 'not-allowed' }}>Agregar mentor</Button>
            </div>
          </Col>
        </Row>
        <TeachersList
          mentorList={mentorList}
          setModalState={(data) => setModalState(data)}
          modalState={modalState}
        />
        {pagination.totalPages > 1 && (
          <Row className="mt-4">
            <Col className="d-flex justify-content-center">
              <Pagination>
                <Pagination.First
                  disabled={pagination.currentPage === 1}
                  onClick={() => getMentors(1)}
                />
                <Pagination.Prev
                  disabled={pagination.currentPage === 1}
                  onClick={() => getMentors(pagination.currentPage - 1)}
                />
                {(() => {
                  const current = pagination.currentPage;
                  const total = pagination.totalPages;
                  const items = [];
                  if (total <= 7) {
                    for (let page = 1; page <= total; page++) {
                      items.push(
                        <Pagination.Item
                          key={page}
                          active={page === current}
                          onClick={() => getMentors(page)}
                        >
                          {page}
                        </Pagination.Item>
                      );
                    }
                  } else {
                    items.push(
                      <Pagination.Item
                        key={1}
                        active={current === 1}
                        onClick={() => getMentors(1)}
                      >
                        1
                      </Pagination.Item>
                    );
                    if (current > 4) {
                      items.push(<Pagination.Ellipsis key="ellipsis-left" />);
                    }
                    const start = Math.max(2, current - 1);
                    const end = Math.min(total - 1, current + 1);

                    for (let page = start; page <= end; page++) {
                      items.push(
                        <Pagination.Item
                          key={page}
                          active={page === current}
                          onClick={() => getMentors(page)}
                        >
                          {page}
                        </Pagination.Item>
                      );
                    }
                    if (current < total - 3) {
                      items.push(<Pagination.Ellipsis key="ellipsis-right" />);
                    }
                    if (total > 1) {
                      items.push(
                        <Pagination.Item
                          key={total}
                          active={current === total}
                          onClick={() => getMentors(total)}
                        >
                          {total}
                        </Pagination.Item>
                      );
                    }
                  }
                  return items;
                })()}

                <Pagination.Next
                  disabled={pagination.currentPage === pagination.totalPages}
                  onClick={() => getMentors(pagination.currentPage + 1)}
                />
                <Pagination.Last
                  disabled={pagination.currentPage === pagination.totalPages}
                  onClick={() => getMentors(pagination.totalPages)}
                />
              </Pagination>
            </Col>
          </Row>
        )}
        <Row className="mt-2">
          <Col className="text-center">
            <small className="text-muted">
              Mostrando {mentorList.length} de {pagination.totalRecords} mentores
              {pagination.totalPages > 1 && ` - Página ${pagination.currentPage} de ${pagination.totalPages}`}
            </small>
          </Col>
        </Row>
      </Container>
    )
  }
}
